import { Tag } from 'lucide-react';
import { resolveChipConfig } from './categoryIconRegistry';

export const getPickerOptionIcon = (option, sectionName = '') => {
  if (option?.icon) return option.icon;
  const { icon } = resolveChipConfig(option?.name || '', option?.parentName || sectionName || '');
  return icon || Tag;
};

export const PickerOptionIcon = ({
  option,
  sectionName = '',
  className = 'text-slate-400',
  sizeClassName = 'h-4 w-4',
  wrapperClassName = 'flex h-5 w-5 shrink-0 items-center justify-center',
  strokeWidth = 1.75,
}) => {
  const Icon = getPickerOptionIcon(option, sectionName);
  return (
    <span className={wrapperClassName} aria-hidden="true">
      <Icon className={`${sizeClassName} ${className}`.trim()} strokeWidth={strokeWidth} />
    </span>
  );
};
